require('./sentry');
require('./bootstrap');
require('./fileReader');
require('./master');
require('./export');
require('./invoice-export');
require('./functions');
require('./buying');
require('./history');
require('./vendors');
require('./orders');
require('./leads');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
});
